export class ApplyForLeavesReq{
    applyForLeavesId: number;

    constructor(applyForLeavesId: number){
        applyForLeavesId = applyForLeavesId;
    }
}